//  non-dynamic
import SHome from "./SHome_web"
export default SHome
